import React, { useEffect } from "react";
import { useRouter, Route } from "../common/Router";

const HistoryBackProcessor: React.FC = () => {
  const { setLoc, loc } = useRouter();

  useEffect(() => {
    const interval = setInterval(() => {
      const hash = window.location.hash.replace("#", "");
      if (loc !== hash) {
        setLoc(hash === "" ? "login" : (hash as Route));
      }
    }, 100);
    return (): void => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default HistoryBackProcessor;
